export default __webpack_public_path__ + "static/media/energijaBalkana.9cbd353b.png";